import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { GasComparatorResult } from 'src/app/components/account/models/GasComparatorResult';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-comparator-gas-result',
  templateUrl: './comparator-gas-result.component.html',
  styleUrls: ['./comparator-gas-result.component.scss']
})
export class ComparatorGasResultComponent implements OnInit {

  @Input('gasComparatorResult') public gasComparatorResult: GasComparatorResult;
  @Input('isEditable') public isEditable: boolean = true;
  @Input('isMobileView') public isMobileView: boolean;
  @Input('comparatorForm') comparatorForm: FormGroup;

  public offerTypeName: string = "Denumirea ofertei-tip";
  public offerType: string = "Tipul ofertei";
  public naturalGasPrice: string = "Preţ gaze naturale (lei/MWh)";
  public shippingCost: string = "Cost de transport (lei/MWh)";
  public distributionCost: string = "Tarif de distribuţie (lei/MWh)";
  public supplyPriceLeiMwh: string = "Preţ de furnizare (lei/MWh)";
  public supplyPriceLeiKwh: string = "Preţ de furnizare (lei/KWh)";
  public cfValue: string = "Valoare Componentă fixă (abonament) (lei/zi)";
  public comparisonResult: string = "Rezultat comparație preţ oferta-tip/preţ actual (include si valoarea abonamentului lunar) (%)";
  public invoiceValue: string = "Valoare factură estimată conform ofertei-tip (include si valoarea abonamentului lunar) (cu TVA, si acciza, după caz) (lei)";
  public economyCost: string = "Economie/Cost suplimentar lunar (lei)";
  public offerDetails: string = "Detalii oferta";
  public offerName: string = "Denumire oferta";
  public offerValability: string = "Valabilitate oferta";
  public clientType: string = "Tip client";
  public connectionMethod: string = "Modalitate de racordare";
  public consumptionCategory: string = "Categoria de consum";
  public regulatedServicesIncluded: string = "Servicii reglementate incluse în preţ";
  public lastUpdate: string = "Ultima actualizare";
  public contractModel: string = "Model contract";
  public contractDuration: string = "Durata contractului";
  public guarantees: string = "Garantii";
  public invoiceFrequency: string = "Frecventa emitere factura";
  public invoiceMode: string = "Mod transmitere factura";
  public documentsMode: string = "Mod transmitere documente pentru incheiere contract";
  public discountsOffered: string = "Reduceri oferite";
  public contractTerminationFees: string = "Comisioane pentru încetarea contractului";
  public contractTerminationFeestooltip: string = "Comisioane percepute pentru încetarea contractului de furnizare a gazelor naturale încheiate pe o durată determinată şi cu preţuri fixe, în situaţia denunţării unilaterale a acestuia de către clientul final, înainte de ajungerea la termen a contractului.";
  public reducedApplicationTime: string = "Durata aplicare reducere";
  public priceStructure: string = "Structura pretului din oferta tip";
  public supplyPrice: string = "Pret furnizare";
  public priceTypeGas: string = "Tip pret gaze naturale";
  public priceApplicationPeriod: string = "Perioada de aplicare a pretului gazelor naturale dupa incheierea contractului aferent ofertei";
  public transportPrice: string = "Cost de transport";
  public distributionRate: string = "Tarif de distributie";
  public fixedComponent: string = "Valoare componenta fixa(abonament) (lei/zi)";
  public download: string = "Descarca";
  public comparatorDocumentsUrl = environment.comparatorDocumentsUrl + "furnizori_gaz/";
  public isDetailsExpanded: boolean;
  public insertActualprice: string = "(introduceți prețul actual)";
  public enterEstimatedConsumption: string = "(introduceți consumul estimat)";
  public enterData: string = "(introduceți datele)";
  public paymentTerm: string = "Termen de plata";
  public invoiceTransmissionNethod: string = "Mod transmitere factură";
  public exciseDuty: string = "Acciza";
  public tva: string = "TVA";
  public tvaValue: number;
  public supplyPriceValue: number;

  ngOnInit(): void {
    this.tvaValue = (this.onConvertToNumber(this.gasComparatorResult.tva) / 100) *
      (this.gasComparatorResult.pg + this.gasComparatorResult.tt + this.gasComparatorResult.t0 + this.onConvertToNumber(this.gasComparatorResult.acciza));
    this.supplyPriceValue = this.onConvertToNumber(this.gasComparatorResult.pret_furnizare_mwh) +
      this.onConvertToNumber(this.gasComparatorResult.acciza) + this.tvaValue;
  }

  showDetails(): void {
    this.isDetailsExpanded = !this.isDetailsExpanded;
  }

  onConvertToNumber(value: any, decimals?: number): number {
    if (!value) {
      return 0;
    }
    if (typeof value === 'string') {
      value = parseFloat(value.replace(",", "").replace(/--/, "-"));
    }
    return decimals ? parseFloat(value.toFixed(decimals)) : value;
  }

  get fixedComponentMonthly(): number {
    return this.onConvertToNumber(this.gasComparatorResult.cf) * 30;
  }

}
